import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupPriceType } from "src/components/Shared/NewForms/NFLookupPriceType";
import { NFLookupSalesOrders } from "src/components/Shared/NewForms/NFLookupSalesOrders";
import { NFLookupVendor } from "src/components/Shared/NewForms/NFLookupVendor";
import { NFLookupVariant } from "src/components/Shared/NewForms/NFLookupVariant";
import { useTranslation } from "react-i18next";
import { EnumHelper } from "src/helpers/EnumHelper";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";

export const SalesOrdersDetailServices = ({}) => {
  const { t } = useTranslation();

  return (
    <>
      <NFormTable fieldArray={"services"}>
        <NFLookupSalesOrders title={t("salesOrder")} fieldName="salesOrderId" width={200} />
        <NFLookupProduct title={t("Product")} fieldName="productId" width={200} />
        <NFLookupUnit title={t("Unit")} fieldName="unitId" width={150} />
        <NFLookupPriceType title={t("PriceType")} width={150} fieldName="priceTypeId" />
        <NFLookupVendor title={t("vendorCode")} fieldName="vendorCode" width={150} />
        <NFLookupVariant title={t("variant")} fieldName="variant" width={150} />
        <NFIntInput title={t("Quantity")} fieldName="quantity" />
        <NFIntInput title={t("Price")} fieldName="price" width={100} />
        <NFIntInput title={t("Amount")} fieldName="amount" />
        <NFLookupInput title={t("vatType")} fieldName={"vatType"} items={EnumHelper.GetVatTypeArrayForLookup()} width={150} />
        <NFIntInput title={t("amountVat")} fieldName="amountVat" />
        <NFIntInput title={t("amountWithVat")} fieldName="amountWithVat" />
        <NFIntInput title={t("vatRate")} fieldName="vatRate" />
      </NFormTable>
    </>
  );
};
